import React, { useEffect, useState, useRef } from "react";
import { DialogPdfHLPure, Label } from "../../pures";
import { useMediaQuery, Grid } from "@material-ui/core";
import { PlusBlue } from "../../../assets/logos/icons";
import IneFrontTemplate from "../../../assets/logos/icons/frente_INEjpg.jpg";

const ModalUploadIdentityDocument = (props) => {
    let  {
        t,
        toggleModalUpload,
        handleFile,
        handleDeleteFile,
        selectedFile,
        colorBorderContainer,
        documentSelected,
        closeModalUpload
    } = props

    const mobileResolution = useMediaQuery("(max-width:560px)");
    const is912 = useMediaQuery("(max-width:912px)");

    const [photo, setPhoto] = useState(null)
    const [errorPhoto, setErrorPhoto] = useState(false)
    const [messageErrorPhoto, setMessageErrorPhoto] = useState('')

    let heightContainer = mobileResolution ? 350 :  500
    let widthContainer = mobileResolution ? 550 : 770 
    let heightBody = mobileResolution ? 230 : 330

    if(is912) heightContainer = 550

    const inputPhoto = useRef(null);

    const uploadFile = (ref) => ref.current.click();

    useEffect(() => {
        if(selectedFile && documentSelected && documentSelected.url){
            setPhoto(documentSelected.url)
        }
    },[])

    const onImageChange = (event, set) => {
        let messageError = t("uploadIdentityDocument.errors.upload.image")
        if (event.target.files && event.target.files[0]) {
            let type = event.target.files[0].type.split("/");
            if (type[0] === "image" && event.target.files[0].type !== "image/tiff") {
                let reader = new FileReader();
                reader.onload = (e) => {
                    let im = new Image();
                    im.src = e.target.result;
                    let buffer = Buffer.from(e.target.result.substring(e.target.result.indexOf(",") + 1));
                    let mb = buffer.length / 1e6;
                    if(mb > Number(process.env.REACP_APP_MB_UPLOAD_IMAGE_IDENTITY)){
                        messageError =  t("uploadIdentityDocument.modals.upload.description.weight")
                        setErrorPhoto(true)
                        setMessageErrorPhoto(messageError)
                        return
                    }
                    im.onload = () => {
                        set(e.target.result);
                        handleFile(event, documentSelected, e.target.result)
                    };
                };
                reader.readAsDataURL(event.target.files[0]);
                reader = null;
            } else {
                setErrorPhoto(true)
                setMessageErrorPhoto(messageError)
            }
        }
    };

    return (
        <div className="modalUploadIdentityDocument-container">
            <DialogPdfHLPure
                title={`${t("uploadIdentityDocument.modals.upload.title")}: ${(documentSelected && documentSelected.name) ? documentSelected.name : '' }`}
                // description={t("uploadIdentityDocument.modals.upload.description.weight")}
                canelBtn={t("button.cancel")}
                saveBtn={t("upload.btn")}
                width={widthContainer}
                height={heightContainer}
                heightBody={heightBody}
                handleFile={handleFile}
                handleDeleteFile={handleDeleteFile}
                cancel={() => closeModalUpload()}
                handleSubmitProfile={() => toggleModalUpload(documentSelected, false)}
            >
                <div className="grey-txt descriptionDialogBox-collaborator">
                    <p className="descriptionDialogBox-collaborator-container-div-leyend-p">
                        {t("uploadIdentityDocument.modals.upload.description.instructions")}
                    </p>
                    <p className="descriptionDialogBox-collaborator-container-div-leyend-p">
                        {t("uploadIdentityDocument.modals.upload.type.file")}
                    </p>
                    {/* <p className="descriptionDialogBox-collaborator-container-div-leyend-p">
                        {t("uploadIdentityDocument.modals.upload.photo")}
                    </p>
                    <p className="descriptionDialogBox-collaborator-container-div-leyend-p">
                        {t("uploadIdentityDocument.modals.upload.description.clear")}
                    </p> */}
                </div>
                 <div className="uploadIdentityDocument-container-images">
                    <div className="uploadIdentityDocument-ine-front">
                        <div className={"rec-signature-base"}  onClick={() => uploadFile(inputPhoto)}>
                            <img className={"uploadIdentityDocument-image-plus"} src={PlusBlue} width="40" />
                            <img className={(photo) ? "uploadIdentityDocument-image-ine " :"uploadIdentityDocument-image-default"} src={photo ? photo : IneFrontTemplate } />
                        </div>
                        <p className="signatureCredretialForm-p-sub">
                            {t("uploadIdentityDocument.id.front")}
                        </p>
                    </div>
                </div>
            </DialogPdfHLPure>
            <input
                ref={inputPhoto}
                onChange={(e) => onImageChange(e, setPhoto)}
                type="file"
                id="fileKey"
                accept=".jpg, .jpeg"
                style={{ display: "none" }}
            />
        </div>
    )
}

export { ModalUploadIdentityDocument as default }